import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Navigation } from "swiper";
import { useTranslation } from "react-i18next";

const SwiperSlider = ({
  title,
  text,
  children,
  sliderName,
  showAllNavigationUrl,
  hasShowMore,
  hasNavigation = true,
  desc,
  slidesPerView,
  slidesPerViewXxl,
  slidesPerViewXl,
}) => {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  let navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  const showTools = hasNavigation || hasShowMore;

  return (
    <>
      <div className="swiper-header">
        <div className="swiper-header__content">
          <div className="swiper-header__title-row">
            <p className="swiper-header__title font_20 font-extrabold mb-0">
              {title}
              {text ? (
                <span className="font-regular"> {text}</span>
              ) : null}
            </p>
            {showTools && (
              <ul className="swiper-tools">
                {hasNavigation && (
                  <>
                    <li>
                      <button
                        className="btn btn-arrows font_16 font-bold"
                        ref={navigationPrevRef}
                        type="button"
                      >
                        <span className="fas fa-arrow-left fa-fw"></span>
                      </button>
                    </li>
                    <li>
                      <button
                        className="btn btn-arrows font_16 font-bold"
                        ref={navigationNextRef}
                        type="button"
                      >
                        <span className="fas fa-arrow-right fa-fw"></span>
                      </button>
                    </li>
                  </>
                )}
                {hasShowMore && (
                  <li>
                    <button
                      className="btn btn-see-more font_16 font-bold"
                      type="button"
                      onClick={() => navigate(showAllNavigationUrl)}
                    >
                      {t("showAll")}
                    </button>
                  </li>
                )}
              </ul>
            )}
          </div>
          {desc ? (
            <p className="swiper-header__subtitle mb-0 font_14 font-color-grey font-bold">
              {desc}
            </p>
          ) : null}
        </div>
      </div>
      <Swiper
        slidesPerView={slidesPerView ? slidesPerView : 2}
        breakpoints={{
          200: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: slidesPerViewXl ? slidesPerViewXl : 1,
          },
          1280: {
            slidesPerView: slidesPerViewXxl ? slidesPerViewXxl : 2,
          },
        }}
        centeredSlides={false}
        spaceBetween={16}
        navigation={
          hasNavigation
            ? {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }
            : false
        }
        modules={hasNavigation ? [Navigation] : []}
        className={` ${sliderName}`}
      >
        {children}
      </Swiper>
    </>
  );
};

export default SwiperSlider;
